import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import InlineSingleChoice from "../templates/InlineSingleChoice";
import BulletListSingleChoice from "../templates/BulletListSingleChoice";
import Stepper from "../components/Stepper";
import Header from "../components/Header";
import FreeNumberInput from "../templates/FreeNumberInput";
import { SET_LOADING } from "../redux/action-types";
import LoadingBar from "../components/LoadingBar/LoadingBar";
import ErrorHandligPopUp from "../components/ErrorHandlingPopUp";

const getStepsComponents = (steps) => {
  let stepComponents = [];

  steps.forEach((step) => {
    const containsInline = step?.questions?.some(
      (question) => question.questionType === "InlineSingleChoice"
    );
    if (containsInline) {
      stepComponents.push({
        element: (stepProps) => (
          <InlineSingleChoice
            stepProps={stepProps}
            questionDetails={step.questions[0]}
          />
        ),
      });
    } else if (
      step?.questions.some(
        (question) => question.questionType === "BulletListSingleChoice"
      )
    ) {
      stepComponents.push({
        element: (stepProps) => (
          <BulletListSingleChoice
            stepProps={stepProps}
            questionDetails={step.questions[0]}
          />
        ),
      });
    } else if (
      step?.questions.some((question) => question.questionType === "Number")
    ) {
      stepComponents.push({
        element: (stepProps) => (
          <FreeNumberInput stepProps={stepProps} questions={step.questions} />
        ),
      });
    }
  });
  return stepComponents;
};

const QuestionnaireSteps = () => {
  const { steps, userQA, loading, userAccountDetails } = useSelector(
    (state) => state.user
  );
  const [questionnaireSteps, setQuestionnaireSteps] = useState([]);
  const [errHandlingVisible, setErrHanlingVisible] = useState(false);
  const dispatch = useDispatch();
  const [isLoaded, setIsLoaded] = useState(true);

  useEffect(() => {
    if (loading) {
      setIsLoaded(false);
    }
  }, [loading]);

  useEffect(() => {
    if (questionnaireSteps.length === 0) {
      dispatch({ type: SET_LOADING, payload: true });
    } else if (questionnaireSteps.length !== 0 && userAccountDetails) {
      dispatch({ type: SET_LOADING, payload: false });
    }
  }, [dispatch, questionnaireSteps, userAccountDetails]);

  useEffect(() => {
    const stepComponents = getStepsComponents(steps);
    setQuestionnaireSteps(stepComponents);
  }, [steps]);

  useEffect(() => {
    if (userQA?.isRequestValid === false) {
      setErrHanlingVisible(true);
    }
  }, [setErrHanlingVisible, userQA]);

  return (
    <>
      {(!isLoaded || loading) && (
        <LoadingBar isLoading={loading} setIsLoaded={setIsLoaded} />
      )}
      {errHandlingVisible && isLoaded && !loading && (
        <ErrorHandligPopUp setErrHanlingVisible={setErrHanlingVisible} />
      )}
      {questionnaireSteps.length !== 0 && (
        <>
          <Header />
          <Stepper showPrevNext steps={questionnaireSteps} />
        </>
      )}
    </>
  );
};

export default QuestionnaireSteps;
